import { type FC, useMemo } from 'react';
import Input, { type InputProps } from '2-core-elements/FormElements/Input';
import { type ActiveFilter } from './ListingFiltersTypes';
import { getActiveFilterSingleValue, getUpdatedFilters } from './ListingFilterHelpers';

interface ListingFilterInputProps {
    placeholder: string;
    field: string;
    activeFilters: ActiveFilter[]; // current filter that is active (selected)
    setActiveFilters: (newFilters: ActiveFilter[]) => void; // function to update active filters
    disabled?: boolean;
    skin?: InputProps['skin'];
    suffixIcon?: InputProps['suffixIcon'];
    prefixIcon?: InputProps['suffixIcon'];
    onSuffixIconClick?: InputProps['onSuffixIconClick'];
    onPrefixIconClick?: InputProps['onPrefixIconClick'];
    maxLength?: InputProps['maxLength'];
}


const ListingFilterInput: FC<ListingFilterInputProps> = ({
    placeholder,
    field,
    activeFilters,
    setActiveFilters,
    disabled,
    skin,
    onSuffixIconClick,
    onPrefixIconClick,
    suffixIcon,
    prefixIcon,
    maxLength,
}) => {
    const inputValue = useMemo(() => {
        return getActiveFilterSingleValue(activeFilters, field);
    }, [activeFilters, field]);

    const handleClear = (): void => {
        setActiveFilters(
            getUpdatedFilters(
                activeFilters,
                field,
                []
            )
        );
    };

    return (
        <div className="listing-app-filter-item">
            <Input
                debounceTimeout={300}
                placeholder={placeholder}
                suffixIcon={inputValue ? 'cross-circle' : suffixIcon}
                prefixIcon={prefixIcon}
                disabled={disabled}
                onChange={({ target: { value } }): void => {
                    // update the 'search' field with the new value
                    setActiveFilters(
                        getUpdatedFilters(
                            activeFilters,
                            field,
                            value ? [value] : []
                        )
                    );
                }}
                value={inputValue}
                skin={skin}
                onSuffixIconClick={inputValue ? handleClear : onSuffixIconClick}
                onPrefixIconClick={onPrefixIconClick}
                maxLength={maxLength}
            />
        </div>
    );
};

export default ListingFilterInput;
